import { useEffect } from "react"

const BASE_TITLE = "Tonal"

export function useDocumentTitle(title?: string) {
  useEffect(() => {
    const previousTitle = document.title
    document.title = title ? `${BASE_TITLE} - ${title}` : BASE_TITLE

    return () => {
      document.title = previousTitle
    }
  }, [title])
}
